import { utils, writeFile } from "xlsx";
import { getTemplateColumns, TEMPLATE_TITLE } from "./templateColumns";

export type BulkMeterTemplateRow = {
  group?: string;
  seq?: number | null;
  accountNumber: string;
  extractionPointName: string;
  serialNo: string;
};

// Pure: rows → array-of-arrays. Row 1 = title, row 2 = header labels, row 3+ = one row per
// offtake with reading/date/note left blank for the operator. Column set + order come from
// the shared definition, so it always matches what the parser expects.
export const buildTemplateAoa = (
  rows: BulkMeterTemplateRow[],
  opts: { isSeqwater: boolean; headerLabels: string[] },
): (string | number)[][] => {
  const columns = getTemplateColumns(opts.isSeqwater);
  const dataRows = rows.map(row =>
    columns.map(col => {
      const value = (row as Record<string, unknown>)[col.key];
      return value === undefined || value === null ? "" : (value as string | number);
    }),
  );
  return [[TEMPLATE_TITLE], opts.headerLabels, ...dataRows];
};

// Thin side-effect: build the workbook from an AOA and trigger a browser download.
export const triggerTemplateDownload = (aoa: (string | number)[][], fileName: string): void => {
  const worksheet = utils.aoa_to_sheet(aoa);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, "Sheet1");
  writeFile(workbook, fileName);
};
